var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 3.5,
    stroke: "#007F7C",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0026 18.6675L17 12.6675M22.506 16.4395C23.0398 16.0641 23.4401 15.5284 23.6488 14.9101C23.8575 14.2917 23.8638 13.623 23.6666 13.0009C23.2623 11.7242 22.0233 11.0245 20.6843 11.0259H19.9106C19.726 10.3061 19.3805 9.63753 18.9001 9.0706C18.4197 8.50366 17.8169 8.05311 17.1372 7.75285C16.4575 7.45259 15.7185 7.31046 14.9759 7.33716C14.2332 7.36385 13.5064 7.55867 12.8499 7.90696C12.1935 8.25524 11.6247 8.74791 11.1862 9.34787C10.7478 9.94783 10.4511 10.6394 10.3187 11.3706C10.1862 12.1018 10.2214 12.8536 10.4215 13.5692C10.6216 14.2848 10.9814 14.9458 11.474 15.5022",
    stroke: "#007F7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1213 14.2131L17 12.0918L14.8787 14.2131",
    stroke: "#007F7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.023b72a999dd0c05f1ff0fbde65d4d1d.svg";
export { ForwardRef as ReactComponent };